<template>
  <div>
    <v-row>
      <v-col>
        <h2>{{ pageTitle }}</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-form ref="form" lazy-validation v-model="valid">
          <v-row dense>
            <v-col cols="12" align="center">
              <v-text-field
                  label="Название баннера"
                  v-model="banner.name"
                  required
                  :rules="nameRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" align="center">
              <v-text-field
                  label="Заголовок баннера"
                  v-model="banner.title"
                  :rules="nameRules"
                  required
              ></v-text-field>
            </v-col>
            <v-col cols="12" align="center">
              <v-textarea
                  label="Описание баннера"
                  v-model="banner.description"
                  :rules="nameRules"
                  required
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6" align="center">
              <v-text-field
                  label="Ссылка кнопки"
                  v-model="banner.link"
              ></v-text-field>
            </v-col>
            <v-col cols="6" align="center">
              <v-text-field
                  label="Текст кнопки"
                  v-model="banner.buttonText"
              ></v-text-field>
            </v-col
            >
          </v-row>
          <v-row dense>
            <v-col cols="6">
              <v-row>
                <v-col v-show="showFileInput">
                  <v-file-input
                      label="Картинка баннера"
                      variant="outlined"
                      v-model="file"
                      accept="image/*"
                  ></v-file-input
                  >
                </v-col>
                <v-col
                >
                  <div>
                    <span v-show="!showFileInput">{{ banner.fileName }}</span>
                    <v-checkbox
                        v-show="!showFileInput"
                        label="Изменить картинку"
                        v-model="applyImageChange"
                    ></v-checkbox>
                  </div
                  >
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6" align="center">
              <v-checkbox
                  label="Видимость"
                  v-model="banner.enable"
              ></v-checkbox>
            </v-col
            >
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="primary" @click="update" :disabled="isLoading">
                Сохранить
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import {RepositoryFactory} from "@/repositories/RepositoryFactory";

const BannerRepository = RepositoryFactory.get("banner");
export default {
  data() {
    return {
      valid: true,
      isLoading: false,
      banner: {
        id: 0,
        name: "Новый баннер",
        title: null,
        link: null,
        buttonText: null,
        enable: false,
        description: null,
      },
      file: null,
      applyImageChange: false,
      nameRules: [
        (value) => {
          if (value) return true;

          return "Поле обязательно для заполнения.";
        },
      ],
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    async get() {
      if (this.$route.params.id > 0) {
        this.isLoading = true;
        const result = await BannerRepository.get(this.$route.params.id);
        if (result) {
          if (result.data.status === "success") {
            this.banner = result.data.data;
          }
        }
        this.isLoading = false;
      }
    },
    async create() {
      if (!this.valid) {
        return;
      }
      this.isLoading = true;
      const formData = new FormData();
      formData.append("image", this.file[0]);
      if (this.banner.name) {
        formData.append("name", this.banner.name);
      }
      if (this.banner.id) {
        formData.append("id", this.banner.id);
      }
      if (this.banner.title) {
        formData.append("title", this.banner.title);
      }
      if (this.banner.link) {
        formData.append("link", this.banner.link);
      }
      if (this.banner.buttonText) {
        formData.append("buttonText", this.banner.buttonText);
      }
      if (this.banner.enable) {
        formData.append("enable", this.banner.enable);
      }
      if (this.banner.description) {
        formData.append("description", this.banner.description);
      }
      const result = await BannerRepository.create(formData);
      if (result.data.status === "success") {
        this.banner = result.data.data;
        this.$router.replace({path: `/banners/${result.data.data.id}/edit`});
      }
      this.isLoading = false;
    },
    async update() {
      if (!this.valid) {
        return;
      }
      if (this.banner.id > 0) {
        this.isLoading = true;
        const formData = new FormData();
        if (this.file && this.applyImageChange) {
          formData.append("image", this.file[0]);
        }

        if (this.banner.name) {
          formData.append("name", this.banner.name);
        }
        if (this.banner.id) {
          formData.append("id", this.banner.id);
        }
        if (this.banner.title) {
          formData.append("title", this.banner.title);
        }
        if (this.banner.link) {
          formData.append("link", this.banner.link);
        }
        if (this.banner.buttonText) {
          formData.append("buttonText", this.banner.buttonText);
        }
        if (this.banner.enable) {
          formData.append("enable", this.banner.enable);
        }
        if (this.banner.description) {
          formData.append("description", this.banner.description);
        }
        const result = await BannerRepository.update(formData);

        this.isLoading = false;
      } else {
        await this.create(this.banner);
      }
    },
  },
  computed: {
    showFileInput: {
      get() {
        return this.applyImageChange || this.banner.id == 0;
      },
    },
    pageTitle: {
      get() {
        return (
            (this.banner.id > 0 ? "Редактирование " : "Создание ") +
            "баннера '" +
            this.banner.name +
            "'"
        );
      },
    },
  },
};
</script>
